import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M9 22H15C20 22 22 20 22 15V9C22 4 20 2 15 2H9C4 2 2 4 2 9V15C2 20 4 22 9 22Z",
      stroke: "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    _createElementVNode("path", {
      d: "M10.9922 9.57812H12.1123C13.6357 9.57812 14.1811 10.4581 14.1811 11.5436V12.4568C14.1811 13.5423 13.6357 14.4223 12.1123 14.4223H10.9922V9.57812Z",
      stroke: "currentColor",
      "stroke-width": "1.5",
      "stroke-linejoin": "round"
    }, null, -1),
    _createElementVNode("path", {
      d: "M5.5081 12.903H6.85105C7.98157 12.903 8.51976 12.299 8.51976 11.554V10.9272C8.51976 10.1821 7.98157 9.57812 6.85105 9.57812C6.85105 9.57812 8.29253 9.57812 5.5081 9.57812L5.50781 14.4223",
      stroke: "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    _createElementVNode("path", {
      d: "M16.6526 12.3309H18.5312M19.5084 9.57812C19.5084 9.57812 19.4371 9.57812 16.6526 9.57812L16.6523 14.4223",
      stroke: "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ]))]))
}
export default { render: render }